<template>
    <div>
        <w-lab :backUrl="`/mypools/${poolId}`" class="lab-module" v-if="labResult" :pool="labResult" :status-colors="statusColors"></w-lab>
        <w-version/>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'Lab',
    computed: {
        ...mapGetters({
            labResult: 'pools/labResult',
            statusColors: 'pools/statusColors',
            poolId: 'pools/poolId'
        })
    },
    methods: {
        ...mapActions({
            getLabResults: 'pools/getLabResults'
        })
    },
    created () {
        this.getLabResults(this.$route.query.user)
    }
}
</script>

<style scoped lang="scss">
    .dashboard {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .lab-module, .version {
            max-width: 784px;
        }

        @media (max-width: 1024px) {
            .lab-module, .version {
                width: calc(100% - 40px);
            }
        }

        @media (max-width: 768px) {
            .lab-module, .version {
                width: 100%;
                padding-right: 17px;
            }
        }
    }
</style>
